// The start screen's dictation is the session composer's dictation (Adam,
// 13 Sep: the mic-then-cancel bug was fixed once, in the library's hook, and
// this file had a second copy of it). One hook, with this app's endpoint and
// its bearer token, which axios holds for every other request.
import axios from 'axios'
import { useVoiceDictation as useLibraryVoiceDictation } from '../agent'
import useTranscribeEndpoint from './useTranscribeEndpoint'

interface UseVoiceDictationOptions {
  onTranscription: (text: string) => void
}

export default function useVoiceDictation({ onTranscription }: UseVoiceDictationOptions) {
  const auth = axios.defaults.headers.common['Authorization']
  const transcribeEndpoint = useTranscribeEndpoint()
  return useLibraryVoiceDictation({
    onTranscription,
    transcribeEndpoint,
    authHeader: typeof auth === 'string' ? auth : undefined,
  })
}
